// Grid
export const GRID_BREAKPOINT_XSMALL = 320;
export const GRID_BREAKPOINT_SMALL = 768;
export const GRID_BREAKPOINT_MEDIUM = 992;
export const GRID_BREAKPOINT_LARGE = 1200;
export const GRID_BREAKPOINT_XLARGE = 1400;

// Transitions
export const TRANSITION_SLOW = 500;
export const TRANSITION_MEDIUM = 400;
export const TRANSITION_FAST = 300;

// Order brochures
export const ORDER_MAXIMUM_PRIVATE = 5;
export const ORDER_MAXIMUM_INSTITUTION = 100;

/**
 * --> vom Typ “Broschüren [1]” und “Falblatt [2]” in der +/--Auswahl maximal 50 auswählen können, 
--> bei den Materialien vom Typ “Flyer [4]” maximal 100 auswählen können
--> und bei den Materialien vom Typ “Vistenkarte [7]” und “Postkarte [6]” maximal 200 auswählen
 */
export const ORDER_MAXIMUM_INSTITUTION_BROCHURE = 50;
export const ORDER_MAXIMUM_INSTITUTION_LEAFLET = 50;
export const ORDER_MAXIMUM_INSTITUTION_FLYER = 100;
export const ORDER_MAXIMUM_INSTITUTION_BUSINESS_CARD = 200;
export const ORDER_MAXIMUM_INSTITUTION_POST_CARD = 200;

// Cookie
export const COOKIE_EXPIRES = 90; // days
